<template>
  <div>
    <v-app-bar :title="`Admin Console ${subSection}`" >
        <template v-slot:prepend>
          <v-btn icon @click="systemStore.routerTo('home-partner')">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>   
          <div style="margin-left: 10px; border: solid 1px; height: 20px;"></div>
        </template>
      </v-app-bar>


      <v-navigation-drawer
        expand-on-hover
        rail
        permanent 
        :width="325">
        <v-list>
          <v-list-item prepend-icon="mdi-account" title="Member Lookup" value="MemberLookup" @click="selectedOption='MemberLookup'"></v-list-item>
          <v-list-item prepend-icon="mdi-domain" title="Partner Company Lookup" value="PartnerCompanyLookup" @click="selectedOption='PartnerCompanyLookup'"></v-list-item>
          <v-list-item prepend-icon="mdi-warehouse" title="Distributor Company Lookup" value="DistributorCompanyLookup" @click="selectedOption='DistributorCompanyLookup'"></v-list-item>
          <v-list-item prepend-icon="mdi-file-certificate-outline" title="Manage EVouchers" value="ManageEVouchers" @click="selectedOption='ManageEVouchers'"></v-list-item>
          <v-list-item prepend-icon="mdi-certificate-outline" title="Manage EVoucher References" value="ManageEVoucherReferences" @click="selectedOption='ManageEVoucherReferences'"></v-list-item>
          <v-list-item prepend-icon="mdi-cloud-upload-outline" title="Weekly Imports" value="WeeklyImports" @click="selectedOption='WeeklyImports'"></v-list-item>
          <v-list-item prepend-icon="mdi-group" title="Super Disti Role Admin" value="SuperDistiRoleAdmin" @click="selectedOption='SuperDistiRoleAdmin'"></v-list-item>
          <v-list-item prepend-icon="mdi-finance" title="Reports" value="Reports" @click="selectedOption='Reports'"></v-list-item>
          <v-list-item prepend-icon="mdi-auto-upload" title="Auto Redemptions" value="AutoRedemptions" @click="selectedOption='AutoRedemptions'"></v-list-item>
          <v-list-item prepend-icon="mdi-web" title="Translations Admin" value="TranslationsAdmin" @click="selectedOption='TranslationsAdmin'"></v-list-item>
          <v-list-item prepend-icon="mdi-head-question" title="Quiz Zone" value="QuizZone" @click="selectedOption='QuizZone'"></v-list-item>
        </v-list>
      </v-navigation-drawer>

      <v-container fluid>
        <MemberLookup v-if="selectedOption==='MemberLookup'" />
        <PartnerCompanyLookup v-if="selectedOption==='PartnerCompanyLookup'" />
        <DistributorCompanyLookup v-if="selectedOption==='DistributorCompanyLookup'" />
        <ManageEVouchers v-if="selectedOption==='ManageEVouchers'"></ManageEVouchers>
        <ManageEVoucherReference v-if="selectedOption==='ManageEVoucherReferences'"></ManageEVoucherReference>
        <WeeklyImports v-if="selectedOption==='WeeklyImports'"></WeeklyImports>
        <QuizZone v-if="selectedOption==='QuizZone'"></QuizZone>
        <SuperDistiRoleAdmin v-if="selectedOption==='SuperDistiRoleAdmin'"></SuperDistiRoleAdmin>
        <Reports v-if="selectedOption==='Reports'"></Reports>
        <AutoRedemptions v-if="selectedOption==='AutoRedemptions'"></AutoRedemptions>
        <TranslationsAdmin v-if="selectedOption==='TranslationsAdmin'"></TranslationsAdmin>
      </v-container>
      <!-- <v-main class="d-flex justify-center ma-5" style="min-height: 90vh;">
        <MemberLookup v-if="selectedOption==='MemberLookup'" />
        <PartnerCompanyLookup v-if="selectedOption==='PartnerCompanyLookup'" />
        <DistributorCompanyLookup v-if="selectedOption==='DistributorCompanyLookup'" />
        <ManageEVouchers v-if="selectedOption==='ManageEVouchers'"></ManageEVouchers>
        <WeeklyImports v-if="selectedOption==='WeeklyImports'"></WeeklyImports>
        <QuizZone v-if="selectedOption==='QuizZone'"></QuizZone>
        <SuperDistiRoleAdmin v-if="selectedOption==='SuperDistiRoleAdmin'"></SuperDistiRoleAdmin>
      </v-main> -->  
  </div>
    
</template>

<script setup>
import { ref, onMounted, watch } from 'vue'
import { useSystemStore } from '@/stores/system'

import MemberLookup from '@/views/AdminMemberLookup.vue'
import PartnerCompanyLookup from '@/views/AdminPartnerCompanyLookup.vue'
import DistributorCompanyLookup from '@/views/AdminDistributorCompanyLookup.vue'
import ManageEVouchers from '@/views/AdminManageEVouchers.vue'
import ManageEVoucherReference from '@/views/AdminManageEVoucherReference.vue'
import WeeklyImports from '@/views/AdminWeeklyImports.vue'
import QuizZone from '@/views/AdminQuizZone.vue'
import SuperDistiRoleAdmin from '@/views/AdminSuperDistiRole.vue'
import Reports from '@/views/AdminReports.vue'
import AutoRedemptions from '@/views/AdminAutoRedemptions.vue'
import TranslationsAdmin from '@/views/AdminTranslations.vue'

const systemStore = useSystemStore()
const selectedOption = ref("")

const subSection = ref('')

watch(
  selectedOption,
  () => subSection.value = ` | ${systemStore.splitCamelCase(selectedOption.value)}`
)

onMounted(() => {})

</script>

<style scoped>

</style>